export const TIIFA_API_URL = process.env.REACT_APP_TIIFA_API_URL as string;
export const AUDIO_API_URL = process.env.REACT_APP_AUDIO_API_URL as string;